import type React from "react";
import type { SelectOption } from "@SeemplicityDev/shared";
import AgentConfigsSection from "./AgentConfigs/AgentConfigsSection";
import CreditPacksSection from "./CreditPacks/CreditPacksSection";

export interface AccountConfigSectionProps {
  accountUuid: string;
}

interface AccountConfigTypeDescriptor {
  label: string;
  Component: React.FC<AccountConfigSectionProps>;
}

export const ACCOUNT_CONFIG_TYPE = {
  AGENT: "agent",
  CREDIT_PACKS: "credit_packs",
} as const;

export type AccountConfigTypeValue =
  (typeof ACCOUNT_CONFIG_TYPE)[keyof typeof ACCOUNT_CONFIG_TYPE];

export const ACCOUNT_CONFIG_TYPES: Record<
  AccountConfigTypeValue,
  AccountConfigTypeDescriptor
> = {
  [ACCOUNT_CONFIG_TYPE.AGENT]: {
    label: "Agent Configurations",
    Component: AgentConfigsSection,
  },
  [ACCOUNT_CONFIG_TYPE.CREDIT_PACKS]: {
    label: "Credit Packs",
    Component: CreditPacksSection,
  },
};

export const ACCOUNT_CONFIG_TYPE_OPTIONS: SelectOption[] = Object.entries(
  ACCOUNT_CONFIG_TYPES
).map(([value, { label }]) => ({ label, value }));

export const isAccountConfigType = (
  value: unknown
): value is AccountConfigTypeValue =>
  typeof value === "string" && value in ACCOUNT_CONFIG_TYPES;
